import { render, staticRenderFns } from "./TeamsCard.vue?vue&type=template&id=02af5132"
import script from "./TeamsCard.vue?vue&type=script&lang=js"
export * from "./TeamsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports